<app-header></app-header>

<router-outlet></router-outlet>

<div class="container">
  <div bsModal #commonModal="bs-modal" [config]="{backdrop: 'static'}" class="modal fade" id="common-modal"
    role="dialog" data-backdrop="static">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-body">
          <p>
            @for (displaytext of commonModalBody; track displaytext) {
              <span>
                {{displaytext.content | translate}}
                @if (displaytext.commonModalHrefLink!==' ') {
                  <a
                  [href]="displaytext.commonModalHrefLink">{{displaytext.commonModalHrefLink}}</a>
                }
              </span>
            }
          </p>
        </div>
        @if (isCommonModalButton) {
          <div class="modal-footer">
            <div class="col text-center">
              <button type="button" class="btn btn-primary btn-lg" data-dismiss="modal"
              (click)="commanModalClose(isSignout)">OK</button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- <div bsModal #successErrorModal="bs-modal" [config]="{backdrop: 'static'}" class="modal fade" id="success-error-modal"
  role="dialog" data-bs-backdrop="static">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header" [ngClass]="isError ? 'generic-errormodal' : 'generic-successmodal'">
        <h4 class="modal-title">
          <i *ngIf="!isError" class="fa fa-check-circle" style="color:green"></i>
          <i *ngIf="isError" class="fa fa-exclamation-triangle" style="color:red"></i> {{genericModalTitle}}
        </h4>
      </div>
      <div class="modal-body">
        <p class="msgInline" *ngIf="isLangKey">{{langaugeKey | translate}}</p>
        <p class="msgInline" *ngIf="!isLangKey">{{langaugeKey}}</p>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary btn-block" data-dismiss="modal"
        (click)="successErrorModalClose(navigateTo)">OK</button>
      </div>
    </div>
  </div>
</div> -->

<div bsModal #successErrorModal="bs-modal" [config]="{backdrop: 'static'}" class="modal fade schedule-modal"
  id="success-error-modal" role="dialog" data-bs-backdrop="static">

  <div class="modal-dialog modal-sm modal-style">

    <div class="modal-content">
      <div class="modal-header  center-footer">
        <h4 class="header-style">
          {{genericModalTitle}}
        </h4>
      </div>

      <div class="modal-body center-footer content-style">
        @if (isLangKey) {
          <p class="msgInline">
            {{langaugeKey | translate}}
          </p>
        }

        @if (!isLangKey) {
          <p class="msgInline">
            {{langaugeKey}}
          </p>
        }
      </div>

      <div class="modal-footer center-footer">
        <button type="button" class="btn btn-primary btn-style" data-dismiss="modal"
          (click)="successErrorModalClose(navigateTo)">
          {{ "lang.OK" | translate }}
        </button>
      </div>
    </div>
  </div>

</div>

</div>

<!--Spinner for loading -->
<ngx-spinner bdColor="rgba(0, 0, 0, 0.41)" [name]="appSpinner" size="medium" type="ball-spin-clockwise"
  [fullScreen]="true">
</ngx-spinner>